import React from 'react';
import classnames from 'classnames';
import Link from 'next/link';
import { useSelector } from 'react-redux';
import { ConUserBrandWebV1ListResponse } from '@/services/swagger/data-contracts';
import LogoWithText from '@/business-components/LogoWithText';
import { RootState } from '@/models';
import styles from './index.module.scss';

export type MyBrandCardProps = {
  className?: string;
  cardClassName?: string;
  authTime?: string;
} & ConUserBrandWebV1ListResponse;

const MyBrandCard: React.FC<MyBrandCardProps> = ({
  conBrandId,
  chName,
  ehName,
  brandInfo,
  // compositeScore,
  commentTime,
  unlockTime,
  subTime,
  collectTime,
  className,
  cardClassName,
  authTime,
}) => {
  const { memberType } = useSelector((state: RootState) => state.user.memberInfo);
  return (
    <Link href={`/brand/${conBrandId}`}>
      <a target="_blank" className={className}>
        <div className={classnames(styles.card, cardClassName)}>
          <LogoWithText
            src={brandInfo?.logoUrl}
            width={80}
            borderRadios={10}
            chName={chName}
            ehName={ehName}
            logoClass={styles.logo}
            spanClass={styles.logoSpan}
            len={6}
          />
          <div className={styles.detail}>
            <div className={styles.nameContainer}>
              <div className={styles.nameAndLabelContainer}>
                <span className={styles.chName}>{chName || ehName}</span>
                {authTime && <span className={styles.authLabel}>已认证</span>}
                {memberType === 'member_investor' && !commentTime && (
                  <span className={styles.noRatingLabel}>未评分</span>
                )}
                {unlockTime && <span className={styles.unlockedLabel}>已解锁</span>}
                {subTime && <span className={styles.subscribedLabel}>已订阅</span>}
                {collectTime && <span className={styles.collectedLabel}>已收藏</span>}
              </div>
              <span className={styles.enName}>{chName ? ehName : ''}</span>
              <span className={styles.fullName}>{brandInfo?.companyChName || brandInfo?.companyEhName}</span>
            </div>
            <div className={styles.detailInfo}>
              <div className={classnames(styles.infoRow, styles.raceTrackInfoRow)}>
                <span className={styles.infoColumn}>
                  <span className={styles.infoName}>所属行业：</span>
                  <span className={styles.infoValue}>{brandInfo?.industryTrackName || '-'}</span>
                </span>
                <span className={styles.infoColumn}>
                  <span className={styles.infoName}>所属赛道：</span>
                  <span className={styles.infoValue}>
                    {brandInfo?.oneLevelTrackName || '-'}
                    {/* {brandInfo.oneLevelTrackName}/{brandInfo.twoLevelTrackName} */}
                  </span>
                </span>
              </div>
              <div className={styles.infoRow}>
                <span className={styles.infoColumn}>
                  <span className={styles.infoName}>所在地区：</span>
                  <span className={styles.infoValue}>{brandInfo?.companyCity || '-'}</span>
                </span>
                <span className={styles.infoColumn}>
                  <span className={styles.infoName}>融资轮次：</span>
                  <span className={styles.infoValue}>{brandInfo?.financeRoundsName || '-'}</span>
                </span>
              </div>
            </div>
            {/*<div className={styles.splitLine}></div>*/}
            {/*<div className={styles.dataInfo}>*/}
            {/*  <div className={styles.scoreContainer}>*/}
            {/*    <span className={styles.dataInfoName}>综合指标：</span>*/}
            {/*    <span className={styles.dataInfoValue}>{compositeScore}</span>*/}
            {/*  </div>*/}
            {/*  <div className={styles.rankingContainer}>*/}
            {/*    <span className={styles.dataInfoName}>行业排名：</span>*/}
            {/*    /!* <div> *!/*/}
            {/*    <span className={styles.rankingText}>前</span>*/}
            {/*    <span className={styles.dataInfoValue}>{brandInfo?.rankingRateInIndustry}%</span>*/}
            {/*    /!* </div> *!/*/}
            {/*  </div>*/}
            {/*</div>*/}
          </div>
        </div>
      </a>
    </Link>
  );
};

export default MyBrandCard;
